<div id="dark" class="page-background">
  <div class="settings">
    <div class="container-fluid reports-container">
      <div class="reports-container_title text-center">
        {{ "fundmentalReportsCenter" | translate }}
      </div>
      <div class="reports-container_filter my-4">
        <form [formGroup]="searchForm">
          <div class="form-group">
            <div class="row justify-content-between">
                
            <div class=" row col-9">
                <div class="col-3 ">
                <label
                    class="text-color-theme required"
                    [ngStyle]="translate.currentLang == 'en' && { float: 'left' }"
                    >{{ "type" | translate }} </label>
                <ng-select
                    [searchable]="false"
                    class="custom"
                    required
                    formControlName="type"
                    (change)="getTypeNum($event)"
                >
                    <ng-option *ngFor="let type of types" [value]="type.id">
                    {{ type.name | translate }}
                    </ng-option>
                </ng-select>
                </div>
                <div class="col-3" *ngIf="searchObj?.type == 1">
                    <label
                    class="text-color-theme required"
                    [ngStyle]="translate.currentLang == 'en' && { float: 'left' }"
                    >{{ "indexValue" | translate }}</label
                    >
                    <ng-select
                    [searchable]="false"
                    class="custom"
                    (change)="getTypeValue($event)"
                    name="type"
                    >
                    <ng-option *ngFor="let type of indexTypes" [value]="type.id">
                        {{ type.name | translate }}
                    </ng-option>
                    </ng-select>
                </div>
    
                <div class="col-3" *ngIf="searchObj?.type == 2">
                    <label
                    class="text-color-theme required"
                    [ngStyle]="translate.currentLang == 'en' && { float: 'left' }"
                    >{{ "symbolValue" | translate }}</label
                    >
                    <ng-select
                    [searchable]="true"
                    class="custom"
                    (change)="getTypeValue($event)"
                    >
                    <ng-option
                        *ngFor="let allMarketName of allMarketNames"
                        [value]="allMarketName.SYMBOL_CODE"
                    >
                        {{
                        translate.currentLang == "ar"
                            ? allMarketName.arb_shortname
                            : allMarketName.eng_shortname
                        }}
                    </ng-option>
                    </ng-select>
                </div>

                <div
                class="col-3 d-flex align-items-center justify-content-start alignBtn"
                >
                <button
                    class="btn btn-primary"
                    [ngStyle]="
                    !searchForm.valid && {
                        'background-color': '#6c757d',
                        color: 'lightgrey',
                        border: '1px solid #6c757d'
                    }
                    "
                    [disabled]="!searchForm.valid"
                    (click)="search()"
                >
                    {{ "preview" | translate }}
                </button>
                </div>
              </div>

              <div class="col-3 align-self-end d-flex justify-content-end">
                <span class="text-muted">
                    {{ report.length }} {{'report' | translate}}
                </span>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div
        id="recent-trades"
        class="table-custom"
        style="overflow: auto"
        *ngIf="report.length > 0"
      >
        <table
          datatable
          [dtOptions]="dtOptions"
          class="table table-sm table-dark"
        >
          <thead>
            <tr class="text-center">
              <th class="fit" *ngFor="let item of cols">
                {{ item | translate }}
              </th>
              <th><i class="icon fa fa-print px-1"></i> PDF</th>
              <th>{{ "description" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="text-center" *ngFor="let rowData of rows">
              <td class="fit">
                {{ rowData.CreateDate | date : "medium" }}
              </td>
              <td class="fit">
                {{ rowData.title }}
              </td>
              <td class="fit">
                {{ rowData?.type }}
              </td>
              <td>
                <div class="btn-group" *ngIf="rowData?.Uploads.length > 0">
                  <button
                    type="button"
                    class="btn btn-primary dropdown-toggle"
                    *ngIf="rowData?.Uploads.length == 1"
                    (click)="printPDF(rowData?.Uploads[0])"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="icon fa fa-print px-1"></i> PDF
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary dropdown-toggle"
                    *ngIf="rowData?.Uploads.length > 1"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="icon fa fa-print px-1"></i> PDF
                  </button>
                  <div
                    class="dropdown-menu bg-secondary"
                    *ngIf="rowData?.Uploads.length > 1"
                  >
                    <a
                      class="dropdown-item text-color-theme"
                      *ngFor="let filePath of rowData?.Uploads; index as i"
                      (click)="printPDF(filePath)"
                    >
                      <i class="icon fa fa-print px-1"></i>
                      PDF {{ i + 1 }}
                    </a>
                  </div>
                </div>
              </td>
              <td class="clickable">
                <div
                  *ngIf="rowData?.Desc?.ShortDesc || rowData?.Desc?.Desc"
                  (click)="openDescModal(rowData?.Desc)"
                >
                  <i class="fa fa-book fa-lg"></i>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        *ngIf="report.length == 0"
        class="text-center m-5 mx-auto"
        style="width: 60%"
      >
        <img class="empty-state" src="/assets/img/noData.png" />
        <div class="col-sm-12">
          <ng-container *ngIf="!searchObj?.type">
            <ng-container *ngIf="!(noDataFound && report.length == 0)">
              <h6 class="info-warning mt-2">
                {{ "selectTypeMsg" | translate }}
              </h6>
            </ng-container>
          </ng-container>
          <!-- <h6 class="info-warning mt-2" *ngIf="!searchObj?.type || (noDataFound && report.length==0)">{{ "selectTypeMsg" | translate }}</h6> -->
          <h6 class="info-warning mt-2" *ngIf="noDataFound">
            {{ "noDataFound" | translate }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-loading
  [show]="loading"
  [config]="{ backdropBorderRadius: '3px' }"
></ngx-loading>
